import Calendar from "../payment/calendar";
import Notify from "./../notify";
import Litepicker from "./../litepicker";


export default class CalendarEmployment extends Calendar {

    constructor(id, mounth = false, year = false) {

        super(id, mounth, year, false);
        this.selectedYear = null;
        this.selectedMounth = null;
        this.selectedDay = null;
        this.popupId = "object-create-popup";
        this.popup = null;
        this.dates = {};
        this.buildDates = {};
        this.formData = [];
        this.modalObjectCreate = null;
        this.modalCellDelete = new Foundation.Reveal($("#object-cell-delete"));;
        this.globalDateCreateStart = new Date();
        this.repeatDataIsActive = false;
        this.nextYear;
        this.dateForDelete = null;
        this.dataObjectId = $("#" + id).attr("data-object");
        this.orderedRebuildDates = null;
        this.orderedRebuildDatesEmpty = null;

        if ($("#" + id).length) {
            this.getOrderedDates();
        } else {
            return;
        }




    }
    openModalRepeat() {
        if (this.modalObjectCreate) {
            this.modalObjectCreate.open();
        } else {
            this.modalObjectCreate = new Foundation.Reveal($("#object-create-popup"));
            this.modalObjectCreate.open();
        }

        $("#employment-calendar-container").load("/themes/ahtilahti/ajax/orders_employment_list.php", { data: { action: "get-employments-order", id: this.orderId.split(',') } });
    }


    inArray(needle, haystack) {
        var length = haystack.length;
        for (var i = 0; i < length; i++) {
            if (haystack[i] == needle) return i;
        }
        return false;
    }

    rebuildDays() {
        let instance = this;

        if (this.orderedRebuildDatesEmpty) {

            for (let k in this.orderedRebuildDatesEmpty) {
                if (new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).getTime() < new Date(this.orderedRebuildDatesEmpty[k])) {


                    $("[data-key='" + this.orderedRebuildDatesEmpty[k] + "']").addClass("calendar-date-success");
                } else {
                    $("[data-key='" + this.orderedRebuildDatesEmpty[k] + "']").addClass("calendar-date-disabled");
                }

            }
        }

        if (this.orderedRebuildDates) {
            let clickArrays = [];
            let pos = 0;
            for (let key in this.orderedRebuildDates) {

                let i = 0;
                let datesPaid = [];
                let datesPaidPast = [];
                for (i; i < this.orderedRebuildDates[key].length; i++) {

                    if (new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).getTime() <= new Date(this.orderedRebuildDates[key][i])) {


                        let index = $.inArray(key, datesPaid);


                        if (index == -1) {

                            datesPaid.push(key);

                        }

                        $("[data-key='" + this.orderedRebuildDates[key][i] + "']").addClass("calendar-date-alert");
                        $("[data-key='" + this.orderedRebuildDates[key][i] + "']").attr("data-orders-ids", datesPaid);


                    } else {



                        let index = $.inArray(key, datesPaidPast);


                        if (index == -1) {
                            datesPaidPast.push(key);
                        }


                        $("[data-key='" + this.orderedRebuildDates[key][i] + "']").addClass("calendar-date-past");
                        $("[data-key='" + this.orderedRebuildDates[key][i] + "']").attr("data-orders-ids", datesPaidPast);
                    }

                    // $("[data-key='" + this.orderedRebuildDates[key][i] + "']").on("click", function(e) {
                    //     e.preventDefault();
                    //     instance.orderId = $(this).attr("data-orders-ids");
                    //     instance.cellClick(instance);
                    // });
                    pos = this.inArray(this.orderedRebuildDates[key][i], clickArrays);
                    if (pos === false) {
                        clickArrays.push(this.orderedRebuildDates[key][i]);
                    }

                }
            }
            for (let cell in clickArrays) {
                $("[data-key='" + clickArrays[cell] + "']").on("click", function(e) {
                    e.preventDefault();
                    instance.orderId = $(this).attr("data-orders-ids");
                    instance.cellClick(instance);
                });
            }

        }


    }

    getMinStaticDateForOrder() {
        return {
            mounth: new Date().getMonth() + 1,
            year: new Date().getFullYear()
        }
    }
    getDatesForOrder() {
        return [];
    }
    getOrderedDates() {

        let $orderedArray = [];
        let instance = this;

        $.ajax({
            method: "POST",
            url: "/themes/ahtilahti/ajax/orders_employment_list.php",
            data: {
                action: "get-employments-orders",
                data: {
                    id: this.dataObjectId,
                },
            },
            success: function(response) {

                let res;
                typeof response === "string" ?
                    (res = $.parseJSON(response)) :
                    (res = response);


                if (res.success) {

                    instance.orderedRebuildDates = res.ordered;
                    instance.orderedRebuildDatesEmpty = res.empty;
                    instance.rebuildDays();
                }
            },

            error(xhr, status, error) {
                console.log(error);
            },
        });

    }
    createMonth() {
        let inst = this;
        let mounthContainer = document.createElement("div");
        mounthContainer.classList.add(
            "sect",
            "grid-x",
            "grid-padding-x",
            "align-justify",
            "align-middle"
        );
        if (
            this.staticMinDateMounth < this.currentMonth ||
            this.staticMinDateYear < this.currentYear
        ) {
            let leftArrow = document.createElement("div");
            leftArrow.classList.add("cell", "shrink");

            let linkLeftArrow = document.createElement("a");
            linkLeftArrow.classList.add("calendar-month-link");
            linkLeftArrow.innerHTML = "<i class='fas fa-chevron-left'>";
            leftArrow.appendChild(linkLeftArrow);
            mounthContainer.appendChild(leftArrow);

            linkLeftArrow.addEventListener("click", function(e) {
                e.preventDefault();

                inst.currentMonth = inst.currentMonth - 1;

                if (inst.currentMonth < 0) {
                    inst.currentMonth = 11;
                    inst.currentYear = parseInt(inst.currentYear) - 1;
                }

                inst.init(true);
            });



        }

        let rightArrow = document.createElement("div");
        rightArrow.classList.add("cell", "shrink");

        let linkRightArrow = document.createElement("a");
        linkRightArrow.classList.add("calendar-month-link");
        linkRightArrow.innerHTML = "<i class='fas fa-chevron-right'>";
        rightArrow.appendChild(linkRightArrow);

        linkRightArrow.addEventListener("click", function(e) {
            e.preventDefault();


            inst.currentMonth = inst.currentMonth + 1;


            if (inst.currentMonth > 11) {
                inst.currentMonth = 0;
                inst.currentYear = parseInt(inst.currentYear) + 1;
            }



            inst.init(true);
        });

        let mounthName = document.createElement("div");
        mounthName.classList.add("cell", "auto", "calendar-month-title");

        //  if (this.currentYear != this.date.getFullYear()) {

        // this.monthes[this.currentMonth] =
        // this.monthes[this.currentMonth] + " " + this.currentYear;
        //  }

        mounthName.innerHTML = this.monthes[this.currentMonth] + " " + this.currentYear;

        mounthContainer.appendChild(mounthName);
        mounthContainer.appendChild(rightArrow);

        return mounthContainer;
    }

    setSelectedDate(y, m, d) {
        this.selectedDay = d;
        this.selectedMounth = m;
        this.selectedYear = y;
    }

    cellClick(instance) {

        // instance.setSelectedDate(instance.firstDay.getFullYear(), instance.firstDay.getMonth() - 1, parseInt(element.getAttribute("data-day")));
        // instance.globalDateCreateStart = new Date(instance.selectedYear, instance.selectedMounth, instance.selectedDay);
        instance.openModalRepeat();

    }

    createDays() {

        let instance = this;
        instance.firstDay = new Date(this.currentYear, this.currentMonth, 1);
        instance.firstDayWeek = instance.firstDay.getDay();
        this.next = this.firstDay.getMonth();
        this.nextYear = this.firstDay.getFullYear();
        instance.t = instance.firstDayWeek - 1;
        if (instance.t < 0) {
            instance.t = 6;
        }
        let daysCalendar = document.createElement("div");

        daysCalendar.classList.add("calendar-dates");
        let a = 0;

        while (this.firstDay.getMonth() == this.currentMonth) {
            let firstDay = this.firstDay;
            let i = 0;



            let row = document.createElement("div");
            row.classList.add("grid-x", "small-up-7", "text-center");


            while (i < 7) {
                let col;
                let day;
                if (a == 0) {
                    if (i < this.t) {
                        col = document.createElement("div");
                        col.classList.add("cell", "calendar-date-none");
                        col.innerHTML = "";
                        col.setAttribute("data-day", this.firstDay.getDate());

                    } else {

                        let colClass = "calendar-date-none";
                        col = document.createElement("div");
                        if (new Date(this.firstDay.getFullYear(), this.firstDay.getMonth(), this.firstDay.getDate()) < new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())) {
                            colClass = "calendar-date-none";
                            col.setAttribute("data-key", new Date(firstDay.getFullYear(), firstDay.getMonth(), this.firstDay.getDate()).getTime());
                        } else {
                            col.setAttribute("data-key", new Date(firstDay.getFullYear(), firstDay.getMonth(), this.firstDay.getDate()).getTime());
                            // col.addEventListener('click', () => instance.cellClick(instance, col));
                        }


                        col.classList.add("cell", colClass);
                        col.innerHTML = "<span class='day'>" + this.firstDay.getDate() + "</span>";
                        col.innerHTML += "<span class='price'></span>";
                        col.setAttribute("data-day", this.firstDay.getDate());

                        this.firstDay.setDate(this.firstDay.getDate() + 1);
                    }
                } else {

                    if (this.next > this.currentMonth || this.nextYear > this.currentYear) {
                        break;
                    }
                    let colClass = "calendar-date-none";
                    col = document.createElement("div");
                    if (new Date(this.firstDay.getFullYear(), this.firstDay.getMonth(), this.firstDay.getDate()) < new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())) {
                        colClass = "calendar-date-none";
                        col.setAttribute("data-key", new Date(firstDay.getFullYear(), firstDay.getMonth(), this.firstDay.getDate()).getTime());
                    } else {
                        col.setAttribute("data-key", new Date(firstDay.getFullYear(), firstDay.getMonth(), this.firstDay.getDate()).getTime());
                        // col.addEventListener('click', () => instance.cellClick(instance, col));

                    }
                    col.classList.add("cell", colClass);

                    col.innerHTML = "<span class='day'>" + this.firstDay.getDate() + "</span>";
                    col.innerHTML += "<span class='price'></span>";
                    col.setAttribute("data-day", this.firstDay.getDate());
                    this.firstDay.setDate(this.firstDay.getDate() + 1);
                    this.next = this.firstDay.getMonth();
                    this.nextYear = this.firstDay.getFullYear();


                }
                row.appendChild(col);
                i++;

            }

            daysCalendar.appendChild(row);
            a++;

        }


        return daysCalendar;
    }







    init(calendar = false) {
        let instance = this;
        if ($("#" + instance.idContainer).length) {
            let mounth = instance.createMonth();
            let days = instance.createDays();
            let weekDays = instance.createWeekDays();
            if (calendar) {
                instance.calendar = document.createElement("div");
                instance.calendar.classList.add("calendar");
            }
            instance.calendar.appendChild(mounth);
            instance.calendar.appendChild(weekDays);
            instance.calendar.appendChild(days);

            $("#" + instance.idContainer).html(instance.calendar);


            instance.rebuildDays();




        }

    }


}


(function($) {

    const calendar = new CalendarEmployment("employment-calendar");
    calendar.init();

})(jQuery);